import { AxiosRequestConfig } from 'axios'

import { UpdateDaypartsPayload } from './types'

const getDayparts = (): AxiosRequestConfig => ({
  url: '/dayparts',
  method: 'GET',
})

const updateDayparts = (payload: UpdateDaypartsPayload): AxiosRequestConfig => ({
  url: '/dayparts',
  method: 'PUT',
  data: payload,
})

export { getDayparts, updateDayparts }
